import { getExpiryStatus, formatDate } from './complianceUtils';

export default function ExpiryBadge({ dateStr, showDate = true, compact = false }) {
  const status = getExpiryStatus(dateStr);

  return (
    <div className="flex flex-col gap-0.5">
      <span
        className={`inline-flex w-fit items-center rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ring-1 ${status.className} ${
          status.blink ? 'animate-pulse' : ''
        }`}
      >
        {status.label}
      </span>
      {showDate && !compact && (
        <span className="font-mono text-[10px] text-logi-text0">{formatDate(dateStr)}</span>
      )}
    </div>
  );
}
